import { SVGProps, Ref, forwardRef } from 'react';

export const FolderArrowRightFilledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M1 5.667C1 2.167 2.167 1 5.667 1h2L8.2 2.333h2.133c3.079 0 4.352.903 4.614 3.501a5 5 0 0 0-.305-.087c-.711-.182-1.535-.247-2.438-.247H3.796c-.903 0-1.727.065-2.438.247q-.18.045-.358.105z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.4 15c3.396 0 4.64-1.102 5.365-4.101.725-3-.165-4-3.561-4H3.796C.4 6.9-.49 7.9.235 10.9s1.97 4.1 5.365 4.1zM8.715 8.2l-.99.99 1.054 1.054H4.666v1.4h4.113L7.725 12.7l.99.99 2.744-2.744z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
FolderArrowRightFilledSize16Glyph.displayName = 'FolderArrowRightFilledSize16Glyph';
